export function withTrailingSlash(url: string): string {
  if (!url) return "/";
  return url.endsWith("/") ? url : url + "/";
}

// Base: pagina "madre" della sagra
export function toSagraHref(slugEid: string): string {
  return withTrailingSlash(`/sagra/${slugEid}`);
}

// Edizione: pagina anno specifico
export function toSagraEditionHref(slugEid: string, year: number | string): string {
  return withTrailingSlash(`/sagra/${slugEid}/${year}`);
}

// Helper per SEO canonical se serve altrove
export function toCanonicalSagraEditionUrl(
  origin: string,
  slugEid: string,
  year: number | string
): string {
  return withTrailingSlash(`${origin.replace(/\/$/, "")}/sagra/${slugEid}/${year}`);
}
